import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import CKEditor from '../editor'

const KeyTakeaways = ({ qkey, saveLogHandler, answers, disabled = false }) => {
  const [description, setDescription] = useState('')
  const [isEditorReady, setIsEditorReady] = useState(false)
  const { clientId, planId, sowId } = useParams()
  const [isInitiallyLoad, setIsInitiallyLoad] = useState(true)
  const logs = localStorage.getItem(`logs-${clientId}-${sowId}-${planId}`)
  const parseValue = JSON.parse(logs)
  const prevValue =
    parseValue?.clientId === clientId && parseValue?.planId === planId
      ? parseValue?.[qkey]
      : ''
  let delayAutoSave

  useEffect(() => {
    if (isEditorReady) {
      if (prevValue) {
        setDescription(prevValue || answers || '')
      } else {
        setDescription(answers || '')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditorReady])

  useEffect(() => {
    if (!isEditorReady || isInitiallyLoad) return
    // eslint-disable-next-line react-hooks/exhaustive-deps
    delayAutoSave = setTimeout(() => {
      saveLogHandler(description)
    }, 5000)

    return () => clearTimeout(delayAutoSave)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [description])

  return (
    <div className='takeaways'>
      <h3 className='mb-point-75 font-open-sans font-22 font-bold review-title'>
        Key Takeaways
      </h3>
      <p className='s6 review-description'>
        While exploring each category with the client, we encourage you to
        identify several key takeaways and patterns that both you and other
        coaches could reference in the future to make sense of these results.
      </p>
      <CKEditor
        data={description}
        onReady={(editor) => {
          setIsEditorReady(true)
        }}
        onFocus={() => {
          setIsInitiallyLoad(false)
        }}
        onChange={(event, editor) => {
          setDescription(editor.getData())
        }}
        onBlur={(event, editor) => {
          clearTimeout(delayAutoSave)
          saveLogHandler(editor.getData())
        }}
        disabled={disabled}
      />
    </div>
  )
}

export default KeyTakeaways
